import {useEffect} from 'react';
import {Formik} from 'formik';
import {Button} from '../common/Button';
import {AddDoctorProps} from '../../constants/types';
import permissionsInfo from '../../constants/permissionsInfo';
import EnsurePermission from '../common/EnsurePermission';
import Spinner from '../common/Spinner';
import {doctorValidationSchema} from '../../constants/validationSchemes';
import useOnUnsavedChanges from '../../hooks/useOnUnsavedChanges';
import {FormGroup} from '@mui/material';
import {TextField} from '../common/formik/fields';

const initialValues: AddDoctorProps = {
  lastName: '',
  firstName: '',
  externalId: ''
};

type AddDoctorComponentProps = {
  toggleAddForm: boolean,
  handleAddDoctor: (
    values: AddDoctorProps,
    resetForm: () => void
  ) => Promise<void>;
  clearErrors: () => void;
  apiValidationError: Nullable<Dictionary<string[]>>
}

const AddDoctor = ({
  handleAddDoctor, apiValidationError, clearErrors, toggleAddForm
}: AddDoctorComponentProps) => {
  return (
    <EnsurePermission elementPermissions={permissionsInfo.doctors.create}>
      <Formik
        initialValues={initialValues}
        validationSchema={doctorValidationSchema}
        validateOnBlur={false}
        onSubmit={async (values, {resetForm}) => {
          await handleAddDoctor(values, resetForm);
        }}
      >
        {({setFieldTouched, submitForm, resetForm,
          errors, values, isSubmitting, isValid, dirty}) => {
          useOnUnsavedChanges(dirty);

          useEffect(() => {
            resetForm({values, errors, touched: {}});
          }, [toggleAddForm]);

          return (
            <tr className="table-form-row">
              <td/>
              <td className="cell form-cell">
                <FormGroup>
                  <TextField
                    size="small"
                    id="lastName"
                    name="lastName"
                    placeholder="Last name*"
                    required
                    apiValidationError={apiValidationError}
                    onBlur={() => {
                      setFieldTouched('lastName', true);
                    }}
                    onFocus={() => clearErrors()}
                  />
                </FormGroup>
              </td>

              <td className="cell form-cell">
                <FormGroup>
                  <TextField
                    size="small"
                    id="firstName"
                    name="firstName"
                    placeholder="First name*"
                    required
                    apiValidationError={apiValidationError}
                    onBlur={() => {
                      setFieldTouched('firstName', true);
                    }}
                    onFocus={() => clearErrors()}
                  />
                </FormGroup>
              </td>

              <td className="cell form-cell">
                <FormGroup>
                  <TextField
                    size="small"
                    id="externalId"
                    name="externalId"
                    placeholder="External ID"
                    apiValidationError={apiValidationError}
                    onBlur={() => {
                      setFieldTouched('externalId', true);
                    }}
                    onFocus={() => clearErrors()}
                  />
                </FormGroup>
              </td>

              <td className="cell form-cell narrow-cell">
                <Button testId="create-operation"
                  disabled={isSubmitting || !isValid}
                  type="submit"
                  label="Add record"
                  variant="contained"
                  onClick={() => submitForm()}>
                  {isSubmitting ? <Spinner embedded /> : null}
                </Button>
              </td>
            </tr>);
        }}
      </Formik>
    </EnsurePermission>
  );
};

export default AddDoctor;
